import footer from '@/components/elements/footer'
import header from '@/components/elements/header'
import ModalDialog from '@/components/elements/ModalDialog'
import ModalWelcome from '@/components/elements/ModalWelcome'
import ViewPackage from '@/components/view/setting/ViewPackage'
import { PAGE, PAGE_GROUP } from '@/constants/page.js'
import { FEATURE } from '@/constants/feature.js'
import moment from 'moment'
import dropdown from 'vue-dropdowns'
import { mapGetters } from 'vuex'
import { AM_DRMEK_ALL_IN_ONE_CHAT_MANAGE } from '@/constants/access-menu.js'
import api from '@/api'

const ANANDA_ADMIN_IDS = ['Merrirind.U', 'Suangshanok.K', 'Kansinee.A', 'Admin_CSC1', 'Admin_CSC2']

export default {
  // name: "dashboard",
  components: {
    'app-header': header,
    'app-footer': footer,
    dropdown,
    ViewPackage,
    ModalDialog,
    ModalWelcome
  },
  computed: {
    toacrmagentmanagement() {
      return (
        ['toacrm'].includes(this.selectedBot.theme) &&
        this.$store.state.privilege.role == 'superadmin'
      )
    },
    mitsuWebchatAgentmanagement() {
      return (
        ['mitsuwebchat'].includes(this.selectedBot.theme) &&
        this.$store.state.privilege.role == 'superadmin'
      )
    },
    nestleAcommerceGroup() {
      return (
        this.$store.state.nestlePages.some((page) => page.pageid == this.selectedBot.pageid) &&
        this.$store.state.admingroupid &&
        this.$store.state.admingroupid === '420'
      )
    },
    ...mapGetters({
      selectedBot: 'selectedBot',
      botlist: 'botlist',
      isSelectedBot: 'isSelectedBot',
      isFacebook: 'isFacebook',
      currentLang: 'currentLang',
      showModalWelcome: 'showModalWelcome',
      isCustomerSupportService: 'isCustomerSupportService'
    }),
    isTicket2agent() {
      if (
        ['studio7', 'ticket2', 'ustore'].includes(this.selectedBot.theme) &&
        ['agent', 'superadmin'].includes(this.$store.state.privilege.role)
      ) {
        return true
      } else return false
    },
    isJuzmatchCrm() {
      return PAGE.JUZMATCH_CRM.includes(this.selectedBot.pageid)
    },
    isBeaconPage() {
      return this.$store.state.beaconPageIdList.includes(this.selectedBot.pageid)
    },
    pluginMenu() {
      if (this.selectedBot.theme == 'bblcareer') {
        return 'Job Applicants'
      } else if (this.selectedBot.theme == 'grampablokof') {
        return 'Membership'
      } else if (this.selectedBot.theme == 'tero') {
        return 'Questionaire'
      } else if (this.selectedBot.theme == 'toacrm' || this.selectedBot.theme == 'toaecoupon') {
        return 'Reward manager'
      } else if (this.selectedBot.theme == 'plern') {
        return 'Voucher Code'
      } else {
        return 'Plug-In'
      }
    },
    isDefaultTheme() {
      return this.$vuetify.theme.primary == '#FF706B'
    },
    isPremiumExpired() {
      let expire = this.$store.state.selectedBot.expireat
      let today = moment(new Date()).format('YYYY-MM-DDTHH:mm:ss.SSS')
      let register = this.$store.state.selectedBot.registerat
      return expire > register && expire < today
    },
    showUpsell1: function () {
      if (this.$store.getters.showAlert('upsell1') >= 0) {
        var alert = this.$store.getters.showAlert('upsell1')
        return alert.show
      } else {
        return true
      }
    },
    showAlertLine: function () {
      if (this.$store.getters.showAlert('line') >= 0) {
        var alert = this.$store.getters.showAlert('line')
        return alert.show
      } else {
        return true
      }
    },
    showAlertExpiredPackage: function () {
      if (this.$store.getters.showAlert('expriedPackage') >= 0) {
        var alert = this.$store.getters.showAlert('expriedPackage')
        return alert.show
      } else {
        return true
      }
    },
    showAlertExpiredPremium: function () {
      if (this.$store.getters.showAlert('expriedPremium') >= 0) {
        var alert = this.$store.getters.showAlert('expriedPremium')
        return alert.show
      } else {
        return true
      }
    },
    optionBotlist: function () {
      return this.botlist
        .map((el) => {
          if (el.pageid == this.selectedBot.pageid) return null
          return { name: el.pagename, value: el.pageid }
        })
        .filter((el) => {
          return el != null
        })
        .sort((a, b) => {
          var nameA = a.name.toUpperCase() // ignore upper and lowercase
          var nameB = b.name.toUpperCase() // ignore upper and lowercase
          if (nameA < nameB) {
            return -1
          }
          if (nameA > nameB) {
            return 1
          }

          // names must be equal
          return 0
        })
    },
    filterBotlist: function () {},
    isTremendous() {
      return PAGE.TREMENDOUS.includes(this.selectedBot.pageid)
    },
    isRoots() {
      return PAGE.ROOTS.includes(this.selectedBot.pageid)
    },
    isAira() {
      return PAGE.AIRA.includes(this.selectedBot.pageid)
    },
    isDDProperty() {
      if (this.selectedBot) {
        if (PAGE.DDPROPERTY.includes(this.selectedBot.pageid)) {
          return true
        }
      }
      return false
    },
    isAssetWise() {
      return ['assetwise'].includes(this.selectedBot.theme)
    },
    isTigerpolySystemAdmin() {
      return (
        ['tigerpoly'].includes(this.selectedBot.type) &&
        this.$store.state.privilege &&
        ['superadmin', 'systemadmin', 'adminsystem'].includes(this.$store.state.privilege.role)
      )
    },
    hideShopServicesMenu() {
      let isHide = this.selectedBot.hide_template
      if (
        [...this.$store.state.lamyPage, ...PAGE.MORDEE, ...PAGE.DR_MEK, ...PAGE.SUPERRICH].includes(
          this.selectedBot.pageid
        ) ||
        [('yasale-ac', 'nongtungjai', 'nt', 'tigerpoly', 'amaze')].includes(
          this.selectedBot.type
        ) ||
        [PAGE_GROUP.SKF].includes(this.selectedBot.page_group)
      ) {
        isHide = true
      }
      return isHide
    },
    isHideFirstAnnouncement() {
      return (
        ['amaze'].includes(this.selectedBot.type) ||
        [PAGE_GROUP.VIBE_VOTE].includes(this.selectedBot.page_group)
      )
    },
    isHotstar() {
      return PAGE.HOTSTAR.includes(this.selectedBot.pageid)
    },
    isSuperrich() {
      return PAGE.SUPERRICH.includes(this.selectedBot.pageid)
    },
    isYasale() {
      return (
        PAGE.YASALE.includes(this.selectedBot.pageid) && this.selectedBot.theme === 'ecommercebasic'
      )
    },
    isJorakay() {
      return PAGE.JORAKAY.includes(this.selectedBot.pageid)
    },
    isOceanPsyjai() {
      return PAGE.OCEAN_PSYJAI.includes(this.selectedBot.pageid)
    },
    isSrichand() {
      return this.selectedBot.page_group === PAGE_GROUP.SRICHAND
    },
    isCIMBWealthPage() {
      return this.selectedBot.page_group === PAGE_GROUP.CIMB_WEALTH
    },
    isDisabledSurveyIframe() {
      return this.isCIMBWealthPage && ['agent'].includes(this.$store.state.privilege.role)
    },
    isVibeVote() {
      return this.selectedBot.page_group === PAGE_GROUP.VIBE_VOTE
    },
    isSuperrichTestPage() {
      return this.selectedBot.pageid === '1718598395533'
    },
    isAMDrMekAllInOnePage() {
      if (Object.keys(AM_DRMEK_ALL_IN_ONE_CHAT_MANAGE).includes(this.selectedBot.pageid)) {
        const currentUser = AM_DRMEK_ALL_IN_ONE_CHAT_MANAGE[this.selectedBot.pageid]
        return currentUser && currentUser.includes(this.$store.state.userid)
      } else {
        return false
      }
    },
    isAgentRole() {
      return (this.$store.state.privilege || {}).role === 'agent'
    },
    isEnabledAdsManagement() {
      if (this.$store.state.privilege && this.$store.state.privilege.role === 'superadmin') {
        return (
          ['632168973317377', '349756588214372', '677112112147683', '124789727391916'].includes(
            this.selectedBot.pageid
          ) || this.selectedBot.type === 'hino'
        )
      }

      return false
    },
    isHopinn() {
      return ['hopinn', 'hopinn_new'].includes(this.selectedBot.theme)
    }
  },
  data: function () {
    return {
      drawer: null,
      showAds: true,
      autostart: false,
      introConfig: {
        nextLabel: this.$t('Next'),
        prevLabel: this.$t('Back'),
        skipLabel: this.$t('skip'),
        doneLabel: this.$t('Finish')
      },
      myOptions: {
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: 'Skip tour',
          buttonPrevious: 'Previous',
          buttonNext: 'Next',
          buttonStop: 'Finish'
        }
      },
      showMenu: false,
      x: 0,
      y: 0,
      currentBot: null,
      pagelist: [],
      selectedOption: {},
      expriedTime: null,
      expriedDate: null
    }
  },

  methods: {
    isShowMenu(menu) {
      // welcome
      // conversation
      // comment
      // broadcast
      // template
      // livechat
      // dashboard
      // training
      // billing
      // audience

      const withSetting = (items) => {
        if (
          !this.isZwizAdmin() &&
          this.$store.state.privilege &&
          this.$store.state.privilege.role &&
          !['superadmin'].includes(this.$store.state.privilege.role)
        ) {
          return items
        }

        return [...items, 'setting']
      }

      if (this.isAMDrMekAllInOnePage) {
        return withSetting(['livechat']).includes(menu)
      }

      if (PAGE.CIMB.includes(this.selectedBot.pageid)) {
        if (['template', 'comment', 'adsSimulator'].includes(menu)) {
          return false
        }
      }

      if (this.isJorakay) {
        return withSetting(['dashboard']).includes(menu)
      }
      if (this.isOceanPsyjai) {
        return withSetting(['conversation', 'dashboard', 'training']).includes(menu)
      }
      if (this.isVibeVote && !this.isZwizAdmin()) {
        return withSetting(['welcome', 'conversation', 'training']).includes(menu)
      }
      if (
        this.isSuperrich &&
        this.isSuperrichTestPage &&
        !this.isSomeRole(['superadmin']) &&
        menu !== 'advancesetting'
      ) {
        return withSetting([
          'ticket3checkin',
          'ticket3ticketmanagement',
          'ticket3agentmanagement',
          'welcome',
          'livechat'
        ]).includes(menu)
      }

      if (['lon-broadcast'].includes(menu)) {
        if (
          !!this.selectedBot.features &&
          [...this.selectedBot.features.split(',')].includes(FEATURE.LINE_OFFICIAL_NOTIFICATION)
        ) {
          return true
        }
        return false
      }
      if (['gpt'].includes(menu)) {
        if (
          !!this.selectedBot.features &&
          [...this.selectedBot.features.split(',')].includes(FEATURE.GPT)
        ) {
          return true
        }
        return false
      }
      if (['ticket3agentmanagement', 'ticket3checkin', 'ticket3ticketmanagement'].includes(menu)) {
        if ([...PAGE.KMB_AGENT].includes(this.selectedBot.pageid)) {
          if (
            this.$store.state.privilege &&
            this.$store.state.privilege.role &&
            ['agent'].includes(this.$store.state.privilege.role)
          ) {
            return ['ticket3ticketmanagement', 'ticket3agentmanagement', 'ticket3checkin'].includes(
              menu
            )
          }
          return true
        } else {
          if (
            ['ticket3agentmanagement'].includes(menu) &&
            this.selectedBot.unlock_ticket_3 &&
            this.$store.state.privilege &&
            this.$store.state.privilege.role &&
            ['agent'].includes(this.$store.state.privilege.role)
          ) {
            return false
          } else {
            return this.selectedBot.unlock_ticket_3
          }
        }
      }
      if (['whatsapp'].includes(menu)) {
        if (
          this.selectedBot.unlock_ticket_3 &&
          this.$store.state.privilege &&
          this.$store.state.privilege.role &&
          ['agent'].includes(this.$store.state.privilege.role)
        ) {
          return false
        } else {
          return this.selectedBot.whatsapp_account_id
        }
      }
      if (['beacon'].includes(menu)) {
        if (
          this.selectedBot.unlock_ticket_3 &&
          ['agent'].includes(this.$store.state.privilege.role)
        ) {
          return false
        } else {
          return this.selectedBot.unlock_beacon
        }
      }
      if (['facebook-template'].includes(menu)) {
        return this.selectedBot.unlock_facebook_template
      }
      if (['advancesetting'].includes(menu)) {
        if (
          this.selectedBot.unlock_ticket_3 &&
          this.$store.state.privilege &&
          this.$store.state.privilege.role &&
          ['agent'].includes(this.$store.state.privilege.role)
        ) {
          return false
        } else {
          return this.$store.state.userid.includes('zwiz')
        }
      }
      if (['audience'].includes(menu)) {
        return this.selectedBot.unlock_audience
      }
      if (
        [
          'welcome',
          'conversation',
          'comment',
          'broadcast',
          'template',
          'dashboard',
          'training',
          'adsSimulator',
          'beacon'
        ].includes(menu) &&
        this.selectedBot.unlock_ticket_3 &&
        this.$store.state.privilege &&
        this.$store.state.privilege.role &&
        ['agent'].includes(this.$store.state.privilege.role)
      ) {
        return false
      }

      if ([...PAGE.KMB_AGENT].includes(this.selectedBot.pageid)) {
        if (this.$store.state.privilege.role && this.$store.state.privilege.role === 'supervisor') {
          return ['livechat'].includes(menu)
        }
      }

      if (!this.selectedBot.hide_template && ['template'].includes(menu)) {
        if (PAGE.ANANDA.includes(this.selectedBot.pageid)) {
          return !ANANDA_ADMIN_IDS.includes(this.$store.state.userid)
        }

        return !['delta'].includes(this.selectedBot.type) && !this.isSrichand
      }

      if (['survey'].includes(menu)) {
        if ([...PAGE.KMB_AGENT].includes(this.selectedBot.pageid)) {
          if (
            this.$store.state.privilege &&
            this.$store.state.privilege.role &&
            ['agent', 'supervisor'].includes(this.$store.state.privilege.role)
          ) {
            return false
          }
        }

        return (
          this.selectedBot.unlock_survey &&
          !['tigerpoly', 'phyathai', 'skf'].includes(this.selectedBot.type) &&
          !['warroom'].includes(this.selectedBot.theme) &&
          !this.isCustomerSupportService
        )
      }
      if (['survey-iframe'].includes(menu)) {
        if (this.isDisabledSurveyIframe) {
          return false
        }

        if ([...PAGE.KMB_AGENT].includes(this.selectedBot.pageid)) {
          if (
            this.$store.state.privilege &&
            this.$store.state.privilege.role &&
            ['agent', 'supervisor'].includes(this.$store.state.privilege.role)
          ) {
            return false
          }
        }

        return (
          this.selectedBot.unlock_survey &&
          (['skf'].includes(this.selectedBot.type) ||
            ['warroom'].includes(this.selectedBot.theme) ||
            this.isCustomerSupportService)
        )
      }
      if (['webchat-iframe'].includes(menu)) {
        return this.selectedBot.unlock_webchat
      }
      if (['lineRichMenu'].includes(menu)) {
        if (this.isCIMBWealthPage) return !this.isAgentRole
        return (this.selectedBot.features || '').split(',').includes(FEATURE.LINE_RICH_MENU)
      }
      if (['eventTracking'].includes(menu)) {
        if (this.isCIMBWealthPage) return !this.isAgentRole
        return (this.selectedBot.features || '').split(',').includes(FEATURE.EVENT_TRACKING)
      }
      if (['notification-center'].includes(menu)) {
        return this.isZwizAdmin() || [PAGE_GROUP.YASALE_AC].includes(this.selectedBot.page_group)
      }
      if (['tiktok'].includes(menu)) {
        if (this.isCIMBWealthPage) return !this.isAgentRole
        return (this.selectedBot.features || '').split(',').includes(FEATURE.UNLOCK_TIKTOK)
      }
      if (['drive'].includes(menu)) {
        return this.isZwizAdmin()
      }
      if (['axa-car-management'].includes(menu)) {
        return [PAGE_GROUP.AXA].includes(this.selectedBot.page_group)
      }
      if (this.selectedBot.theme == 'scgdistribution') {
        return !['training'].includes(menu)
      }

      if (PAGE.DR_MEK.includes(this.selectedBot.pageid)) {
        if (this.$store.state.privilege.role === 'superadmin') {
          return true
        } else if (['staff'].includes(this.$store.state.privilege.role)) {
          return ['conversation', 'livechat', 'comment'].includes(menu)
        } else {
          return ['livechat'].includes(menu)
        }
      } else if (
        PAGE.MORDEE.includes(this.selectedBot.pageid) &&
        this.$store.state.privilege.role === 'admin'
      ) {
        return ['livechat'].includes(menu)
      } else if (this.selectedBot.theme === 'seagull') {
        if (['admin', 'superadmin'].includes(this.$store.state.privilege.role)) {
          return true
        } else if (['supervisor', 'agent'].includes(this.$store.state.privilege.role)) {
          return ['ticketmanagement', 'livechat', 'template'].includes(menu)
        } else if (this.$store.state.privilege.role === 'warehouse') {
          return ['template'].includes(menu)
        }
        return false
      } else if (this.selectedBot.theme == 'kingkitchen') {
        if (
          this.$store.state.privilege &&
          (this.$store.state.privilege.role === 'so' ||
            this.$store.state.privilege.role === 'installation')
        ) {
          return ['admin_menu'].includes(menu)
        } else {
          return true
        }
      } else if (
        this.$store.state.toacustomerpage.includes(this.selectedBot.pageid) &&
        ['TOAadminliveChat01', 'TOAadminliveChat02'].includes(this.$store.state.userid)
      ) {
        return ['livechat'].includes(menu)
      } else if (this.selectedBot.theme == 'toacrm') {
        if (this.$store.state.privilege && this.$store.state.privilege.role == 'superadmin') {
          return true
        } else if (this.$store.state.privilege && this.$store.state.privilege.role === 'admin') {
          return ['template', 'livechat'].includes(menu)
        } else {
          return ['template'].includes(menu)
        }
      } else if (['toaecoupon'].includes(this.selectedBot.theme)) {
        /*  admin
        trade
        approval
        approver1
        approver2
        superadmin */
        if (
          this.$store.state.privilege &&
          ['admin', 'trade', 'approval', 'approver1', 'approver2', 'superadmin'].includes(
            this.$store.state.privilege.role
          )
        ) {
          return true
        } else return false
        // } else if ([...this.$store.state.toaPaintPage].includes(this.selectedBot.pageid)) {
        //   return !['template'].includes(menu)
      } else if (
        ['studio7', 'ticket2', 'ustore'].includes(this.selectedBot.theme) ||
        [...this.$store.state.toaPaintPage].includes(this.selectedBot.pageid)
      ) {
        if (this.$store.state.privilege) {
          if (this.$store.state.privilege.role == 'agent') {
            if (this.selectedBot.theme == 'ustore') {
              return ['profile', 'ticketmanagement', 'livechat', 'dashboard'].includes(menu)
            } else {
              return ['profile', 'ticketmanagement', 'livechat'].includes(menu)
            }
          } else if (this.$store.state.privilege.role == 'chatbot') {
            return !['profile', 'ticketmanagement', 'agentmanagement', 'template'].includes(menu)
          } else if (this.$store.state.privilege.role == 'superadmin') {
            return [
              'profile',
              'ticketmanagement',
              'livechat',
              'agentmanagement',
              'dashboard'
            ].includes(menu)
          } else if (this.$store.state.privilege.role == 'systemadmin') {
            return !['template'].includes(menu)
          }
        } else return ['livechat'].includes(menu)
      } else if (this.selectedBot.type === 'amaze') {
        return ['welcome', 'dashboard-amaze', 'conversation', 'dashboard', 'training'].includes(
          menu
        )
      } else if (
        this.selectedBot.theme == 'ticket' ||
        this.$store.state.ticketThemeList.includes(this.selectedBot.theme) ||
        this.$store.state.ticketPageid.includes(this.selectedBot.pageid)
      ) {
        if ([...PAGE.RATCHTHANI].includes(this.selectedBot.pageid)) {
          if (this.$store.state.privilege && this.$store.state.privilege.role) {
            if (this.$store.state.privilege.role === 'superadmin') {
              return true
            } else {
              return ['ticket', 'livechat'].includes(menu)
            }
          }
        } else {
          if (this.$store.state.privilege && this.$store.state.privilege.agent_management) {
            if (
              this.$store.state.ticketPageid.includes(this.selectedBot.pageid) ||
              [...PAGE.JUZMATCH_SALE, ...PAGE.JUZMATCH_CRM].includes(this.selectedBot.pageid)
            ) {
              return !['template'].includes(menu)
            } else if ([...PAGE.ROOTS].includes(this.selectedBot.pageid)) {
              return !['template', 'comment'].includes(menu)
            } else {
              return true
            }
          } else {
            if ([...this.$store.state.oceanlifePage].includes(this.selectedBot.pageid)) {
              return ['livechat', 'dashboard'].includes(menu)
            } else if (this.nestleAcommerceGroup) {
              //group acommerce
              return ['template'].includes(menu)
            } else {
              return ['livechat'].includes(menu)
            }
          }
        }
      } else if (this.selectedBot.theme == 'toa' && this.selectedBot.pagerole == 'livechat') {
        this.$router.push('livechat')
        return ['livechat'].includes(menu)
      } else if (['101836095321926', '367570166993820'].includes(this.selectedBot.pageid)) {
        if (this.$store.state.privilege && this.$store.state.privilege.mjd_management == true) {
          return true
        } else {
          this.$router.push('template')
          return ['template'].includes(menu)
        }
      } else if ([...this.$store.state.lamyPage].includes(this.selectedBot.pageid)) {
        // Lamy
        if (this.$store.state.privilege && this.$store.state.privilege.role == 'staff') {
          return ['template'].includes(menu)
        } else {
          return true
        }
      } else if (this.selectedBot.theme == 'webchat') {
        return !['template'].includes(menu)
      } else if (this.selectedBot.type === 'yasale-ac') {
        if (this.$store.state.privilege && this.$store.state.privilege.role === 'superadmin') {
          return true
        } else return ['template'].includes(menu)
      } else if (this.$store.state.menubypageid[this.selectedBot.pageid]) {
        return this.$store.state.menubypageid[this.selectedBot.pageid].includes(menu)
        // } else if([...this.$store.state.shoptheme].includes(this.selectedBot.theme)) { //Shop theme
        //   return !['agentmanagement'].includes(menu)
      } else if (this.selectedBot.theme == 'secap') {
        if (this.$store.state.privilege.role == 'admin') {
          return ['template'].includes(menu)
        } else {
          return true
        }
      } else if (this.selectedBot.theme == 'warroom') {
        if (this.$localStorage.get('app_type') === 'warroom') {
          return ['TrueidSystemMaintenance'].includes(menu)
        }
        return true
      } else if (this.selectedBot.type === 'somwang') {
        return withSetting(['comment', 'broadcast', 'dashboard']).includes(menu)
      } else if (this.selectedBot.type == 'uu') {
        if (
          ['agent_aya01', 'agent_aya02', 'agent_takhli01', 'agent_takhli02'].includes(
            this.$store.state.userid
          )
        ) {
          return ['livechat', 'broadcast', 'dashboard'].includes(menu)
        } else {
          return true
        }
      } else if (this.selectedBot.theme === 'aira') {
        let showMenu = ['livechat']

        if (this.$store.state.privilege && this.$store.state.privilege.general_permission) {
          const generalPermission = this.$store.state.privilege.general_permission

          if (generalPermission.chatbot_management) {
            showMenu.push('welcome', 'conversation', 'comment', 'dashboard', 'training', 'billing')
          }
          if (generalPermission.admin_user_management) {
            showMenu.push('agentManagement')
          }
          if (generalPermission.seminar_management) {
            showMenu.push('seminarManagement')
          }
          if (generalPermission.member_management) {
            showMenu.push('memberManagement')
          }
        }

        if (this.$store.state.privilege && this.$store.state.privilege.broadcast_permission) {
          const broadcastPermission = this.$store.state.privilege.broadcast_permission

          if (broadcastPermission.create_broadcast || broadcastPermission.approve_broadcast) {
            showMenu.push('broadcast')
          }
        }
        return [...showMenu].includes(menu)
      } else if (this.isDDProperty) {
        return !['template'].includes(menu)
      } else if (this.selectedBot.theme === 'tcp') {
        if (this.$store.state.privilege.role === 'superadmin') {
          return true
        } else if (this.$store.state.privilege.role === 'admin') {
          return ['livechat', 'dashboard'].includes(menu)
        } else if (this.$store.state.privilege.role === 'agent') {
          return !['template'].includes(menu)
        }
      } else if (this.selectedBot.theme === 'loligo' || this.selectedBot.theme == 'letussea') {
        if (this.$store.state.privilege.role === 'superadmin') {
          return true
        } else if (this.$store.state.privilege.role === 'agent') {
          return ['livechat'].includes(menu)
        }
      } else if (this.selectedBot.type === 'delta') {
        if (this.$store.state.privilege.role === 'admin') {
          return ['livechat', 'dashboard'].includes(menu)
        } else {
          return true
        }
      } else if (this.isYasale) {
        return withSetting([
          'welcome',
          'conversation',
          'template',
          'dashboard',
          'training'
        ]).includes(menu)
      } else if (this.isSrichand) {
        return !['adsSimulator'].includes(menu)
      } else if (
        PAGE.ANANDA.includes(this.selectedBot.pageid) &&
        ANANDA_ADMIN_IDS.includes(this.$store.state.userid)
      ) {
        return withSetting(['livechat']).includes(menu)
      } else {
        return menu === 'setting' ? withSetting([]).includes(menu) : true
      }
    },
    onGoHome() {
      location.href = '/' + this.$i18n.locale() + '/allbots'
    },
    clickAds() {
      var prefix = window.location.hostname == 'cms.zwiz.ai' ? 'z_' : ''
      // this.$ga.event('event', prefix + 'banner_5999', this.selectedBot.pagename)
      this.$router.push('upgrade')
    },
    ticket2checkstatus() {
      return new Promise((resolve) => {
        api.ticket2checkstatus(
          { adminId: this.$store.state.userid, pageid: this.selectedBot.pageid },
          (err, response) => {
            if (response.status) {
              resolve(true)
            } else {
              resolve(false)
            }
          }
        )
      })
    },
    logout: async function () {
      var vm = this
      var text = vm.$t('Do you want to Logout?')

      if (['studio7', 'ustore', 'ticket2'].includes(vm.selectedBot.theme)) {
        var isCheckout = await this.ticket2checkstatus()
        if (!isCheckout) {
          text = 'หากคุณลงชื่อออก ระบบจะทำการ Checkout ด้วย'
        }
      }

      vm.$swal
        .fire({
          title: text,
          type: 'question',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then(async (result) => {
          if (result.value) {
            if (['studio7', 'ustore', 'ticket2'].includes(vm.selectedBot.theme) && !isCheckout) {
              await vm.ticket2checkincheckout('check-out')
              await vm.$swal.fire({
                type: 'success',
                text: 'ลงชื่อออกและ Checkout สำเร็จ'
              })
            }
            var isFacebook = vm.isFacebook
            vm.$store.dispatch('logout', null).then()
            if (isFacebook) {
              vm.$router.push('/' + vm.currentLang + '/login')
            } else {
              vm.$router.push('/' + vm.currentLang + '/nigol')
            }
          }
        })
    },
    ticket2checkincheckout(actions) {
      return new Promise((resolve) => {
        var data = {
          adminId: this.$store.state.userid,
          pageid: this.selectedBot.pageid,
          actions // check-in หรือ check-out
        }
        api.ticket2checkincheckout(data, (err, response) => {
          if (response.responsecode == 200) {
            resolve()
          }
        })
      })
    },
    selectBot: function (page) {
      var vm = this
      vm.$store.dispatch('loading')
      $.each(vm.botlist, function (index, bot) {
        if (page.value === bot.pageid) {
          vm.$store.dispatch('selectBot', bot)
        }
      })
      location.reload()
    },
    onError: function (event) {
      $(event.target).attr('src', '/static/img/assets/livechat/profile.png')
    },
    show(e) {
      e.preventDefault()
      this.showMenu = false
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.showMenu = true
      })
    },
    getSetting: function (callback) {
      let vm = this
      var data = {
        pageid: vm.$store.state.selectedBot.pageid
      }

      api.getSetting(data, function (error, response) {
        if (error) {
          console.error(error)
          return
        }

        var contents = {}
        $.each(response.data, function (index, val) {
          contents[val.contenttype] = val
        })
        callback(contents)
      })
    },
    getWelcomeMessage: function (callback) {
      let vm = this
      // vm.$store.dispatch('loading')
      let data = {
        pageid: vm.selectedBot.pageid
      }

      var message = null
      var generics = [
        {
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: true
        }
      ]
      var messages = null
      var type = 'json'
      api.getWelcomeMessage(data, function (error, response) {
        if (error) {
          console.error(error)
          return
        }
        if (response.data) {
          type = response.data.type
          if (type === 'message') {
            messages = [
              [
                {
                  text: response.data.message_text,
                  type: 'text'
                }
              ]
            ]
          } else if (type === 'generic') {
            messages = [[]]
            if (
              response.data.message &&
              typeof response.data.message === 'object' &&
              response.data.message.length > 0
            ) {
              $.each(response.data.message, function (index, val) {
                generics[index] = val
              })

              messages[0][0] = {
                type: 'generic',
                data: generics,
                ratio: response.data.ratio == 'horizontal' ? 'horizontal' : 'square'
              }
            }
          } else {
            if (vm.isJsonParseable(response.data.message)) {
              messages = JSON.parse(response.data.message)
            }
          }
          type = 'json'
        }
        callback({
          type: type,
          message: message,
          generics: generics,
          messages: messages
        })
      })
    },
    toggleBotStatus: async function () {
      let bot = Object.assign({}, this.selectedBot)
      bot.status = !bot.status
      this.$store.dispatch('loading')
      await this.$store.dispatch('toggleBotStatus', bot)
      this.botStatus = bot.status
      this.$store.dispatch('loading')
    },
    isSomeRole(values) {
      const privilege = this.$store.state.privilege
      if (!privilege) return false
      return values.includes(this.$store.state.privilege.role)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/layouts/MenuList/MainMenuList.js